export default "/images/vendor/flag-icon-css/flags/1x1/br.svg?b3663866f502ec386f0ee9bc6df5ecdc";